import { createSelector } from 'reselect'

// Selector para obtener el estado del usuario
export const selectUserState = (state) => state.user

// Selector memorizado para obtener los datos del usuario
export const selectUserData = createSelector([selectUserState], (userState) => userState.userData)
